import { render } from "./RefundBooking.vue?vue&type=template&id=220e9346&scoped=true&lang=pug"
import script from "./RefundBooking.vue?vue&type=script&lang=ts"
export * from "./RefundBooking.vue?vue&type=script&lang=ts"

import "./RefundBooking.vue?vue&type=style&index=0&id=220e9346&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-220e9346"

export default script